import { Button, Icon, Message } from '@bitcine/cinesend-theme'
import { useParams } from 'react-router-dom'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import Details from './details'
import useStore from '../../hooks/use_store'
import Page from '../../components/layouts/page'
import useAuth from '../../hooks/use_auth'
import { modelTypes } from '../../constants/model_types'
import { useEffect, useRef } from 'react'
import InterstitalAdsTable from './cycle_interstitial_ads_table'
import { useSnackbar } from '../../hooks/use_snackbar'

const Cycle = () => {
  const { updateModel } = useStore()
  const params = useParams()
  const queryClient = useQueryClient()
  const { addMessage } = useSnackbar()
  const wasAutofilling = useRef(false)

  const {
    data: cycle,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['cycles/', params.cycleID],
    refetchInterval: (data) => (data?.is_autofilling ? 2000 : false),
    refetchIntervalInBackground: false,
  })

  const { canEditModel: canEditCycle } = useAuth(modelTypes.Cycle, cycle)

  useEffect(() => {
    wasAutofilling.current = false
  }, [params.cycleID])

  useEffect(() => {
    if (wasAutofilling.current && cycle && !cycle.is_autofilling) {
      queryClient.invalidateQueries(['cycles/'])
      addMessage('Auto-fill complete')
    }
    if (cycle) {
      wasAutofilling.current = !!cycle.is_autofilling
    }
  }, [cycle?.is_autofilling])

  const isAutofilling = updateModel.isLoading || !!cycle?.is_autofilling

  return (
    <Page
      title={cycle?.description}
      pending={isLoading}
      error={error}
      buttons={[
        canEditCycle && (
          <Button
            key={cycle?.id + 'autorenew'}
            tertiary
            size='small'
            disabled={isAutofilling}
            icon={!isAutofilling && 'autorenew'}
            onClick={() =>
              updateModel.mutate({
                endpoint: 'cycles',
                id: params.cycleID + '/auto-fill',
                silent: true,
              })
            }
          >
            {isAutofilling && (
              <Icon key={cycle?.id + 'Icon'} icon='autorenew' className='animate-spin-slow text-base mr-2' />
            )}
            Auto-Fill
          </Button>
        ),
      ]}
    >
      {cycle ? <Details cycle={cycle} /> : null}
      {cycle?.issues && cycle.issues.length > 0 && (
        <Message error={true} small={true} className='h-auto mt-4'>
          <ul className={cycle.issues.length > 1 ? 'list-disc list-inside' : 'list-none'}>
            {cycle.issues.map((issue) => (
              <li className='' key={issue.id}>
                {issue.description}
              </li>
            ))}
          </ul>
        </Message>
      )}
      {cycle ? <InterstitalAdsTable cycle={cycle} /> : null}
    </Page>
  )
}

export default Cycle
